module.exports = __webpack_public_path__ + "static/media/person_sehoon.59854577.png";